import React, { ReactElement } from "react";

import CheckPermissions from "../../CheckPermissions";

import { COMPONENTS } from "@utils/Constants";

export const BundleWTPApproachLazy = async (): Promise<{
  Component: () => React.ReactElement;
}> => {
  const { default: BundleWTPApproach } = await import("@workflows/bundles/configurations/wtp-approach");
  const WrappedRules = (): ReactElement => (
    <CheckPermissions name={COMPONENTS.BUNDLES_WTP_APPROACH}>
      <BundleWTPApproach />
    </CheckPermissions>
  );
  return { Component: WrappedRules };
};
